import { createRoot } from "react-dom/client";
import App from "./App";
import "./ieLayout";   // THE SCREEN LAYOUT: caP'n's phone / PC placements from src/data/ie-layout.json, edited on the Sun Dial's Screens page (port 3037)

// DEV ONLY: ?leaguePreview=live shows the League on a made-up week (ui/leaguePreview.jsx). Dead code in a production build.
let Root = App;
if (process.env.NODE_ENV !== "production" && /[?&]leaguePreview/.test(window.location.search)) Root = require("./ui/leaguePreview.jsx").default;
// DEV ONLY: ?poseLab (=champion|lord) shows every being running the fight animations (ui/poseLab.jsx).
if (process.env.NODE_ENV !== "production" && /[?&]poseLab/.test(window.location.search)) Root = require("./ui/poseLab.jsx").default;
// DEV ONLY: ?artLab fires every Art and every being's strike through the fight's own pump (ui/artLab.jsx).
if (process.env.NODE_ENV !== "production" && /[?&]artLab/.test(window.location.search)) Root = require("./ui/artLab.jsx").default;

createRoot(document.getElementById("root")).render(<Root />);
